import MeetingDetails from "./MeetingDetails";

export default MeetingDetails;
